export default __webpack_public_path__ + "static/media/producto-13.6ca9048b.jpg";